import numeral from "numeral";

export default value => numeral(value * 100).format("0[.]00");
